import Image from 'next/image';
import { useMemo } from 'react';
import { NETWORKS } from 'src/common/types/network';

import useGetChainInfo from '@/hooks/useGetChainInfo';
import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const MorphoTriggerDetails = ({ trigger, triggerType }: Props) => {
  const { getChainIconUrl } = useGetChainInfo();

  const vaultAddress = useMemo(() => {
    if (!trigger.signature) return '';
    const match = trigger.signature.match(/@([^@]+)$/);
    return match ? match[1] : '';
  }, [trigger.signature]);

  const networkInfo = useMemo(() => {
    if (!trigger.signature) return null;
    const match = trigger.signature.match(/Fees-(\w+)@/);
    if (!match) return null;

    const networkName = match[1].toLowerCase();
    return NETWORKS.find((network) => network.name.toLowerCase() === networkName);
  }, [trigger.signature]);

  const scannerUrl = useMemo(() => {
    if (!vaultAddress || !networkInfo) return '';
    return getAddressScannerUrl('chainId', networkInfo.chainId, vaultAddress) || '';
  }, [vaultAddress, networkInfo]);

  const chainIconUrl = useMemo(() => {
    if (!networkInfo) return '';
    return getChainIconUrl(networkInfo.chainId) || '';
  }, [networkInfo, getChainIconUrl]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Vault"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            {chainIconUrl && <Image src={chainIconUrl} width={12} height={12} alt={networkInfo?.name || 'chain'} />}
            <span>{maskAddressValue(vaultAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
